export const ProposalProjectConstants = {
    STATUS_STEP1: 'step1',
    STATUS_STEP2: 'step2',
    STATUS_STEP3: 'step3',
    STATUS_STEP4: 'step4',
    STATUS_STANDBY: 'standby',
    STATUS_ACCEPTED: 'accepted',
    STATUS_REFUSED: 'refused',
    STATUS_FINISHED: 'finished',
    WORKFLOW_STEP1_TO_STEP2: 'step1_to_step2',
    WORKFLOW_STEP2_TO_STEP1: 'step2_to_step1',
    WORKFLOW_USER_TO_ADMIN: 'user_to_admin',
    WORKFLOW_ADMIN_TO_USER: 'admin_to_user',
    WORKFLOW_STEP3_TO_STEP4: 'step3_to_step4',
    WORKFLOW_STEP4_TO_STEP3: 'step4_to_step3',
    WORKFLOW_ADMIN_APPROVES: 'admin_approves',
    WORKFLOW_ADMIN_REJECTS: 'admin_rejects',
    WORKFLOW_PROJECT_FINISHED: 'project_finished',
    WORKFLOW_ADMIN_STANDBY: 'admin_to_standby',
    WORKFLOW_ADMIN_STANDBY_TO_STEP4: 'admin_to_step4'
};